import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {Modulos} from 'src/app/core/modulos';
import {AcessoModuloResolver} from 'src/app/guards/acesso-modulo.resolve';
import {AuthGuard} from 'src/app/guards/auth.guard';
import {CadastrarFeriadoComponent} from './cadastrar-feriado/cadastrar-feriado.component';
import {FeriadoComponent} from './feriado.component';

const routes: Routes = [
    {
        path: 'feriado/cadastrar',
        component: CadastrarFeriadoComponent,
        canActivate: [AuthGuard],
        resolve: {perfilAcesso: AcessoModuloResolver},
        data: {modulo: Modulos.FERIADO}
    },
    {
        path: 'feriado',
        component: FeriadoComponent,
        canActivate: [AuthGuard],
        resolve: {perfilAcesso: AcessoModuloResolver},
        data: {modulo: Modulos.FERIADO}
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class FeriadoRoutingModule {
}
